import styled from 'styled-components';

export const CustomStartsWrapper = styled.div`
  display: flex;
  posiiton: relative;
`;
